// ==========================================================================
// Browser sniffing
// Unfortunately, due to mixed support, UA sniffing is required
// ==========================================================================
import is from './is';

const browser = {
  isIE: /* @cc_on!@ */ false || !!document.documentMode,
  isEdge: window.navigator.userAgent.includes('Edg'),
  isWebkit: 'WebkitAppearance' in document.documentElement.style && !/Edge/.test(navigator.userAgent),
  isOsx: navigator.platform.toLowerCase().includes('mac'),
  // isIPhone: (/(iPhone|iPod)/gi.test(navigator.platform) || is.function(window.WebKitPlaybackTargetAvailabilityEvent)),
  // isIos: (/(iPad|iPhone|iPod)/gi.test(navigator.platform) || is.function(window.WebKitPlaybackTargetAvailabilityEvent)),
  isIPhone: (/iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) && !window.MSStream,
  isIos: (/iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) && !window.MSStream,
  isChrome: !window.navigator.userAgent.includes('Edg') && window.navigator.userAgent.includes('Chrome'),
  isAtLeastIE11: !!(navigator.userAgent.match(/Trident/) && !navigator.userAgent.match(/MSIE/)),
  x64: typeof window.navigator.cpuClass != 'undefined' ? window.navigator.platform.toLowerCase() == 'win64'
    && window.navigator.cpuClass.toLowerCase() == 'x64' : window.navigator.platform.toLowerCase() == 'win64',
  isAndroid: window.navigator.userAgent.toLowerCase().includes('android') || window.navigator.userAgent.toLowerCase().includes('linux'),
};

export default browser;
